import { template } from "@ember/template-compiler";
import { on } from '@ember/modifier';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import LinkButton from 'ember-simplepractice/components/spds/action/button/link';
import Message from 'ember-simplepractice/components/spds/feedback/alert-banner/message';
import styles from './transfer-setup-banner.module.scss';
import t from 'ember-intl/helpers/t';
export default class SiteBillingTransferSetupBanner extends Component {
    @service
    billingTransfer;
    openSetup = ()=>{
        this.billingTransfer.openModal();
    };
    static{
        template(`
    {{#if this.billingTransfer.showBanner}}
      <div class={{styles.component}} data-test-billing-transfer-banner>
        <Message
          @type="info"
          @includeIcon={{true}}
          @classNames="icon-inline"
          @header={{t
            "billing.transferSetup.banner.title"
            brandName=this.billingTransfer.brandName
          }}
        >
          <:body>
            <LinkButton
              @text={{t "billing.transferSetup.banner.completeSetup"}}
              class="cta-link"
              data-test-billing-transfer-banner-cta
              {{on "click" this.openSetup}}
            />
          </:body>
        </Message>
      </div>
    {{/if}}
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
